import React, { CSSProperties, useRef } from 'react';
import Slider from 'react-slick';
import SliderButton from '@components/common/sliderButton';
import ContentsListItem from '@components/common/contentsListItem';

import classnames from 'classnames/bind';
import styles from './contentsList.module.scss';
import { usePhsCenterContents } from '@repository/phs/center/usePhsCenter';
const cx = classnames.bind(styles);

const PrevArrow = (props: { className?: string; style?: CSSProperties; onClick?: () => void }) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'prev'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnPrev')}
      theme="dark"
    />
  );
};

const NextArrow = (props: { className?: string; style?: CSSProperties; onClick?: () => void }) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'next'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnNext')}
      theme="dark"
    />
  );
};

const ContentsList = () => {
  const dragging = useRef(false);
  const { data: contentsData } = usePhsCenterContents({ page: 0, size: 12 });

  const contentsListEl = contentsData?.posts?.map((item, index) => {
    return (
      <div className={cx('listItemWrap')} key={index}>
        <ContentsListItem contentData={item} theme="dark" handleDrag={() => !dragging.current} />
      </div>
    );
  });

  const settings = {
    infinite: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: 4,
    slidesToScroll: 4,
    speed: 300,
    cssEase: 'ease-in-out',
    draggable: true,
    beforeChange: () => (dragging.current = true),
    afterChange: () => (dragging.current = false),
  };

  if (!contentsData) return null;
  if (!contentsData?.posts) return null;
  if (!contentsData?.posts?.length) return null;

  return (
    <div className={cx('contentsListArea')}>
      {/* 타이틀 영역 */}
      <strong className={cx('title')}>디챔스에 관한 모든 콘텐츠 모았다!</strong>

      {/* 콘텐츠 리스트 영역 */}
      <div className={cx('contentsListInner')}>
        <Slider {...settings}>{contentsListEl}</Slider>
      </div>
    </div>
  );
};

export default ContentsList;
